import { TopBarConfig } from "../../Components/topbars/topBarFuncs";

export const topBarConfig: TopBarConfig = {
  home: {
    logo: "../dr/logo-ldd-connect.svg",
    alt: "DocServices",
    showAppCode: false,
    logout: "/lddlogout.asp",
    middleIcon: "../dr/logo-ds.svg"
  },
  items: [
      {
          name: "Home",
          icon: "fa-solid fa-house fa-action",
          tooltip: "Home",
          action: "OpenMainPage",
          requireSession: true
      },
      {
          name: "Help",
          icon: "fa-solid fa-circle-question fa-indicator",
          tooltip: "Help",
          action: "handleHelpClick"
      },
      {
          name: "Settings",
          placeholder: true,
          action: "OpenSettings",
          requireSession: true
      }
  ],
  account: {
      icon: "avatar",
      tooltip: "Account",
      popoverItems: [
          {
              label: "Update Password",
              icon: "fa-solid fa-unlock",
              action: "OpenPasswordUpdate",
              type: "action",
              requireSession: true
          },
          {
              label: "Dark Theme",
              icon: "fa-solid fa-moon",
              type: "switch",
              action: null,
              switchProps: {
                  id: "dark-mode-switch",
                  ariaLabel: "Check this switch",
                  defaultChecked: "isDarkTheme",
                  action: "toggleDarkTheme"
              }
          }
      ]
  }
};
